import React from 'react';
import { PageWrapper } from '../PageWrapper';
import { LOGIN_BUTTON_WRAPPER_ID } from './constants';
export var LoginPageComponent = function (_a) {
    var appName = _a.appName, _b = _a.icon, icon = _b === void 0 ? null : _b;
    return (React.createElement(PageWrapper, { appName: appName, icon: icon },
        React.createElement("div", { id: LOGIN_BUTTON_WRAPPER_ID })));
};
//# sourceMappingURL=Component.js.map